(function () {

    let currentSlide = 0;
    let sliderWrapper = null;
  

    const allVariants = window.productVariants || [];
    const productOptions = window.productOptions || [];
    const allImages = window.productImages || [];

    document.addEventListener('DOMContentLoaded', init);

    function init() {
        sliderWrapper = document.getElementById('heroSlider');
        bindSliderNav();
        bindThumbnails();
        bindColorSwatches();
        bindQuantity();
        bindAddToCart();
        bindDesktopSwipe();
        toggleAQIByAirType();
        initMobileSlider();
       bindPincodeCheck()
        pv2BindInstallAdd();
        //pv2RestoreSession();
        setDefaultVariant();
    }

    /* ============================
        DESKTOP SLIDER
    ============================ */

    function getSlides() {
        return document.querySelectorAll('#heroSlider .slide-img');
    }

    function updateSlider() {
        if (!sliderWrapper) return;
        sliderWrapper.style.transform = `translateX(-${currentSlide * 100}%)`;
    }

    function changeSlide(direction) {
        const slides = getSlides();
        if (!slides.length) return;
        currentSlide = (currentSlide + direction + slides.length) % slides.length;
        updateSlider();
    }

    function switchImage(index) {
        currentSlide = index;
        updateSlider();
        document.querySelectorAll('.thumb-box')
            .forEach((t, i) => t.classList.toggle('active', i === index));
    }

    function bindSliderNav() {
        document.querySelectorAll('.slider-nav').forEach(btn => {
            btn.addEventListener('click', function () {
                changeSlide(parseInt(this.dataset.direction));
            });
        });
    }

    function bindThumbnails() {
        document.addEventListener('click', function (e) {
            const thumb = e.target.closest('.thumb-box');
            if (!thumb) return;
            switchImage(parseInt(thumb.dataset.index));
        });
    }

    /* ============================
        VARIANT SYSTEM
    ============================ */

    function getVariantOptionsMap(variant) {
        const map = {};
        productOptions.forEach((opt, index) => {
            map[opt.name.toLowerCase()] = variant[`option${index + 1}`];
        });
        return map;
    }

    function findVariant(color, airtype) {
        return allVariants.find((variant) => {
            const opts = getVariantOptionsMap(variant);

            const colorMatch =
                !color ||
                (opts.color && opts.color.toLowerCase() === color.toLowerCase());

            const airKey = Object.keys(opts).find(k => k.includes('air'));

            const airMatch =
                !airtype ||
                (airKey && opts[airKey]?.toLowerCase() === airtype.toLowerCase());

            return colorMatch && airMatch;
        });
    }

    function updatePageForVariant(variant) {
        if (!variant) return;

        document.querySelectorAll('input[name="id"]')
            .forEach(input => (input.value = variant.id));

        document.querySelectorAll('.cart-btn, .mobile-add-btn')
            .forEach(btn => (btn.dataset.variantId = variant.id));

        document.querySelectorAll('#mobileVariantId')
            .forEach(el => (el.value = variant.id));

        const formattedPrice = '₹' + (variant.price / 100).toLocaleString();
        document.querySelectorAll('.current-price')
            .forEach(el => (el.textContent = formattedPrice));

        const activeColor = document.querySelector('.color-swatch.active');
        if (activeColor) {
            document.querySelectorAll('.color-section .color-label span, #active-color-name')
                .forEach(el => (el.textContent = activeColor.getAttribute('data-color')));
        }

        const optionsText = [variant.option1, variant.option2, variant.option3].join(' ').toLowerCase();
        const isWithout = optionsText.includes('without');

        document.querySelectorAll('[data-heading-with]').forEach(el => {
            el.textContent = isWithout ? el.dataset.headingWithout : el.dataset.headingWith;
        });
        document.querySelectorAll('[data-desc-with]').forEach(el => {
            el.textContent = isWithout ? el.dataset.descWithout : el.dataset.descWith;
        });

        rebuildImages(variant);

        document.dispatchEvent(new CustomEvent('variant:changed', { detail: variant }));
    }

    /* ============================
        REBUILD IMAGES
    ============================ */

    function getImagesForVariant(variant) {
        const options = [
            (variant.option1 || '').toLowerCase(),
            (variant.option2 || '').toLowerCase(),
            (variant.option3 || '').toLowerCase()
        ];

        // Default black — agar koi color option nahi mila toh bhi black dikhao
        const selectedColor = options.find(o => o === 'black' || o === 'white') || 'black';

        const isWithout = options.some(o => o.includes('without'));
        const isWith = options.some(o => o.includes('with') && !o.includes('without'));

        // Step 1: Color + type dono se filter karo
        let filtered = allImages.filter(img => {
            const src = (typeof img === 'string' ? img : img.src || '').toLowerCase();
            const colorMatch = src.includes(selectedColor);
            let typeMatch = true;
            if (isWithout) typeMatch = src.includes('without');
            else if (isWith) typeMatch = src.includes('with') && !src.includes('without');
            return colorMatch && typeMatch;
        });

        // Step 2: Fallback — sirf color se filter (type ignore)
        if (!filtered.length) {
            filtered = allImages.filter(img => {
                const src = (typeof img === 'string' ? img : img.src || '').toLowerCase();
                return src.includes(selectedColor);
            });
        }

        // Step 3: Last fallback — sab dikhao
        return filtered.length ? filtered : allImages;
    }

    function rebuildImages(variant) {
        const images = getImagesForVariant(variant);
        const getSrc = img => (typeof img === 'string' ? img : img.src || '');

        // Desktop slider
        const heroSlider = document.getElementById('heroSlider');
        const thumbStrip = document.getElementById('thumbStrip');

        if (heroSlider && thumbStrip) {
            heroSlider.innerHTML = '';
            thumbStrip.innerHTML = '';

            images.forEach((img, index) => {
                const src = getSrc(img);

                heroSlider.insertAdjacentHTML('beforeend',
                    `<div class="slide-img">
             <img src="${src}" loading="${index === 0 ? 'eager' : 'lazy'}" decoding="async">
           </div>`
                );

                thumbStrip.insertAdjacentHTML('beforeend',
                    `<div class="thumb-box ${index === 0 ? 'active' : ''}" data-index="${index}">
             <img class="thumb-img" src="${src}" loading="lazy" decoding="async">
           </div>`
                );
            });

            currentSlide = 0;
            updateSlider();
        }

        // Mobile slider
        const mobileSlider = document.getElementById('mobileHeroSlider');
        const mobileDotsContainer = document.querySelector('.mobile-slider-dots');

        if (mobileSlider && mobileDotsContainer) {
            mobileSlider.innerHTML = '';
            mobileDotsContainer.innerHTML = '';

            images.forEach((img, index) => {
                const src = getSrc(img);

                mobileSlider.insertAdjacentHTML('beforeend',
                    `<div class="mobile-slide">
             <img src="${src}" loading="${index === 0 ? 'eager' : 'lazy'}" decoding="async">
           </div>`
                );

                mobileDotsContainer.insertAdjacentHTML('beforeend',
                    `<span class="mobile-dot ${index === 0 ? 'active' : ''}" data-index="${index}"></span>`
                );
            });

            requestAnimationFrame(() => initMobileSlider());
        }
    }

    /* ============================
        DEFAULT VARIANT ON PAGE LOAD
    ============================ */

    function setDefaultVariant() {
        const activeColorSwatch = document.querySelector('.color-swatch.active');
        const activeAirBtn = document.querySelector('.airtype-btn.active');

        const color = activeColorSwatch?.dataset.color || 'Black';
        const airtype = activeAirBtn?.dataset.airtype || '';

        const defaultVariant = findVariant(color, airtype);
        if (defaultVariant) {
            rebuildImages(defaultVariant);
        }
    }

    /* ============================
        COLOR SWATCHES
    ============================ */

    function bindColorSwatches() {
        const swatches = document.querySelectorAll('.color-swatch');
        const airBtns = document.querySelectorAll('.airtype-btn');

        function getActiveColor() {
            return document.querySelector('.color-swatch.active')?.dataset.color || '';
        }

        function getActiveAirtype() {
            return document.querySelector('.airtype-btn.active')?.dataset.airtype || '';
        }

        function refreshVariant() {
            const variant = findVariant(getActiveColor(), getActiveAirtype());
            updatePageForVariant(variant);
        }

        swatches.forEach(swatch => {
            swatch.addEventListener('click', function () {
                swatches.forEach(s => s.classList.remove('active'));
                this.classList.add('active');
                refreshVariant();
            });
        });

        airBtns.forEach(btn => {
            btn.addEventListener('click', function () {
                airBtns.forEach(b => b.classList.remove('active'));
                this.classList.add('active');
                refreshVariant();
                toggleAQIByAirType();
            });
        });
    }

    /* ============================
        QUANTITY
    ============================ */

    function bindQuantity() {
        const minus = document.querySelector('.qty-minus');
        const plus = document.querySelector('.qty-plus');
        const input = document.getElementById('quantity');
        const finalQty = document.getElementById('finalQty');

        if (!input) return;

        function update(change) {
            const val = Math.max(1, (parseInt(input.value) || 1) + change);
            input.value = val;
            if (finalQty) finalQty.value = val;
        }

        minus?.addEventListener('click', () => update(-1));
        plus?.addEventListener('click', () => update(1));
    }

    /* ============================
        ADD TO CART
    ============================ */

    function bindAddToCart() {
        let isAdding = false;

        document.addEventListener('click', function (e) {
            const btn = e.target.closest('.cart-btn, .mobile-add-btn');
            if (!btn) return;
            if (isAdding) return;

            const variantId = +btn.dataset.variantId;
            if (!variantId) {
                console.warn('Add to cart: no variant ID found on button');
                return;
            }

            const qty = btn.classList.contains('mobile-add-btn')
                ? +(document.getElementById('mobileQuantity')?.value || 1)
                : +(document.getElementById('quantity')?.value || 1);

            isAdding = true;        // ← Lock
            btn.disabled = true;
            const originalText = btn.textContent;
            btn.textContent = 'Adding…';

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: qty }),
            })
                .then(res => {
                    if (!res.ok) throw new Error(`Cart add failed: ${res.status}`);
                    return fetch(`${window.location.pathname}?section_id=cart-drawer`);
                })
                .then(res => {
                    if (!res.ok) throw new Error(`Cart drawer fetch failed: ${res.status}`);
                    return res.text();
                })
                .then(html => {
                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    const newDrawer = doc.querySelector('cart-drawer');
                    const oldDrawer = document.querySelector('cart-drawer');
                    if (oldDrawer && newDrawer) {
                        oldDrawer.replaceWith(newDrawer);
                        newDrawer.open();
                    }

                    // GTM / dataLayer event

                    /*if (window.dataLayer) {
                      window.dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce: {
                          items: [{
                            item_id: String(variantId),
                            quantity: qty
                          }]
                        }
                      });
                    }*/

                })
                .catch(err => {
                    console.error('Add to cart error:', err);
                    alert('Could not add to cart. Please try again.');
                })
                .finally(() => {
                    isAdding = false;  // ← Unlock
                    btn.disabled = false;
                    btn.textContent = originalText;
                });
        });
    }

    /* ============================
        DESKTOP SWIPE
    ============================ */

    function bindDesktopSwipe() {
        const slider = document.querySelector('.hero-image-slider');
        if (!slider) return;

        let startX = 0;

        slider.addEventListener('touchstart', e => {
            startX = e.touches[0].clientX;
        }, { passive: true });

        slider.addEventListener('touchend', e => {
            const diff = e.changedTouches[0].clientX - startX;
            if (diff > 50) changeSlide(-1);
            if (diff < -50) changeSlide(1);
        }, { passive: true });
    }

    /* ============================
        AQI TOGGLE
    ============================ */

    function toggleAQIByAirType() {
        const activeBtn = document.querySelector('.airtype-btn.active');
        const aqiEl = document.querySelector('.aqi-feature');
        if (!aqiEl) return;

        const isWithout = activeBtn?.dataset.airtype?.toLowerCase().includes('without');
        aqiEl.classList.toggle('is-hidden', !!isWithout);
    }



    function bindPincodeCheck() {
        document.addEventListener('click', function (e) {
            if (e.target.closest('[data-action="pv2-reset"]')) pv2Reset();
        });
        const instances = [
            {
                input: document.getElementById('pv2-pincode-input'),
                btn: document.getElementById('pincode-apply'),
                result: document.getElementById('pv2-result'),
            },
            {
                input: document.getElementById('pv2-pincode-input-mobile'),
                btn: document.getElementById('pincode-apply-mobile'),
                result: document.getElementById('pv2-result-mobile'),
            }
        ].filter(i => i.input && i.btn && i.result);

        instances.forEach(({ input, btn, result }) => {

            input.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') { btn.click(); return; }
                if (
                    !/[0-9]/.test(e.key) &&
                    !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)
                ) {
                    e.preventDefault();
                }
            });

            btn.addEventListener('click', async () => {
                const pin = input.value.trim();

                if (!/^[1-9][0-9]{5}$/.test(pin)) {
                    result.innerHTML = `<div class="pv2-error-row">✗ Please enter a valid 6-digit pincode.</div>`;
                    return;
                }

                const orig = btn.textContent;
                btn.textContent = '...';
                btn.disabled = true;
                result.innerHTML = '';

                try {
                    const res = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
                    const data = await res.json();

                    if (data[0]?.Status === 'Success' && data[0].PostOffice?.length) {
                        const po = data[0].PostOffice[0];
                        const area = `${po.Name}, ${po.District}`;
                        pv2ShowSuccess(result, area, pin, po);
                        pv2SaveSession(pin, area, po);       // ← ADD
                    } else {
                        result.innerHTML = `<div class="pv2-error-row">✗ Sorry, we don't deliver to this pincode yet.</div>`;
                    }
                } catch {
                    pv2ShowSuccess(result, 'Your location', pin, null);
                    pv2SaveSession(pin, 'Your location', null);   // ← ADD
                } finally {
                    btn.textContent = orig;
                    btn.disabled = false;
                }
            });

        });
    }

  
})();

/* ============================
    MOBILE SLIDER + ZOOM
============================ */

function initMobileSlider() {

    const mobileSlider = document.getElementById('mobileHeroSlider');
    if (!mobileSlider) return;

    const slides = Array.from(mobileSlider.querySelectorAll('.mobile-slide'));
    const total = slides.length;
    if (!total) return;

    if (mobileSlider._abortController) {
        mobileSlider._abortController.abort();
    }
    const controller = new AbortController();
    const signal = controller.signal;
    mobileSlider._abortController = controller;

    let current = 0;

    mobileSlider.style.transition = 'none';
    mobileSlider.style.transform = 'translateX(0)';

    function getDots() {
        return Array.from(document.querySelectorAll('.mobile-dot'));
    }

    function updateDots() {
        getDots().forEach((d, i) => d.classList.toggle('active', i === current));
    }

    function goTo(index) {
        current = Math.max(0, Math.min(total - 1, index));
        mobileSlider.style.transition = 'transform 0.38s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        mobileSlider.style.transform = `translateX(-${current * 100}%)`;
        updateDots();
        if (zoomOpen) updateZoom(current);
    }

    getDots().forEach((dot, i) => {
        dot.addEventListener('click', () => goTo(i), { signal });
    });

    let startX = 0, startY = 0, diffX = 0;
    let isDragging = false, isHorizontal = null;

    mobileSlider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        diffX = 0;
        isDragging = true;
        isHorizontal = null;
        mobileSlider.style.transition = 'none';
    }, { passive: true, signal });

    mobileSlider.addEventListener('touchmove', (e) => {
        if (!isDragging) return;

        const moveX = e.touches[0].clientX - startX;
        const moveY = e.touches[0].clientY - startY;

        if (isHorizontal === null && (Math.abs(moveX) > 5 || Math.abs(moveY) > 5)) {
            isHorizontal = Math.abs(moveX) > Math.abs(moveY);
        }

        if (isHorizontal) {
            e.preventDefault();
            diffX = moveX;
            const base = -(current * mobileSlider.parentElement.offsetWidth);
            mobileSlider.style.transform = `translateX(${base + diffX}px)`;
        }
    }, { passive: false, signal });

    mobileSlider.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        mobileSlider.style.transition = 'transform 0.38s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

        if (isHorizontal) {
            const threshold = mobileSlider.parentElement.offsetWidth * 0.2;
            if (diffX < -threshold) goTo(current + 1);
            else if (diffX > threshold) goTo(current - 1);
            else goTo(current);
        }

        diffX = 0;
        isHorizontal = null;
    }, { passive: true, signal });

    window.changeMobileSlide = (dir) => goTo(current + dir);

    updateDots();

    /* ZOOM OVERLAY */

    let zoomOpen = false;
    let zoomIndex = 0;

    const oldOverlay = document.getElementById('mobileZoomOverlay');
    if (oldOverlay) oldOverlay.remove();

    const overlay = document.createElement('div');
    overlay.id = 'mobileZoomOverlay';
    overlay.style.display = 'none';
    overlay.innerHTML = `
    <div class="mz-backdrop"></div>
    <button class="mz-close" aria-label="Close zoom">&#x2715;</button>
    <button class="mz-nav mz-prev" aria-label="Previous">&#10094;</button>
    <div class="mz-img-wrap">
      <img class="mz-image" src="" alt="Product zoom" decoding="async">
    </div>
    <button class="mz-nav mz-next" aria-label="Next">&#10095;</button>
    <div class="mz-dots"></div>
  `;
    document.body.appendChild(overlay);

    const mzImg = overlay.querySelector('.mz-image');
    const mzImgWrap = overlay.querySelector('.mz-img-wrap');
    const mzDotsWrap = overlay.querySelector('.mz-dots');

    slides.forEach((_, i) => {
        const d = document.createElement('span');
        d.className = 'mz-dot' + (i === 0 ? ' active' : '');
        d.addEventListener('click', () => updateZoom(i));
        mzDotsWrap.appendChild(d);
    });

    function syncZoomDots() {
        overlay.querySelectorAll('.mz-dot')
            .forEach((d, i) => d.classList.toggle('active', i === zoomIndex));
    }

    function updateZoom(index) {
        zoomIndex = ((index % total) + total) % total;
        const img = slides[zoomIndex]?.querySelector('img');
        if (!img) return;
        mzImg.style.opacity = '0';
        setTimeout(() => {
            mzImg.src = img.src;
            mzImg.style.opacity = '1';
        }, 120);
        syncZoomDots();
    }

    function openZoom(index) {
        zoomOpen = true;
        zoomIndex = index;
        const img = slides[zoomIndex]?.querySelector('img');
        if (!img) return;
        mzImg.src = img.src;
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        syncZoomDots();
    }

    function closeZoom() {
        zoomOpen = false;
        overlay.classList.remove('active');
        document.body.style.overflow = '';
    }

    overlay.querySelector('.mz-close').addEventListener('click', closeZoom);
    overlay.querySelector('.mz-prev').addEventListener('click', () => updateZoom(zoomIndex - 1));
    overlay.querySelector('.mz-next').addEventListener('click', () => updateZoom(zoomIndex + 1));
    overlay.querySelector('.mz-backdrop').addEventListener('click', closeZoom);

    slides.forEach((slide, i) => {
        slide.style.cursor = 'zoom-in';
        slide.addEventListener('click', () => openZoom(i), { signal });
    });

    let zStartX = 0;
    mzImgWrap.addEventListener('touchstart', e => {
        zStartX = e.touches[0].clientX;
    }, { passive: true });

    mzImgWrap.addEventListener('touchend', e => {
        const diff = e.changedTouches[0].clientX - zStartX;
        if (Math.abs(diff) > 50) updateZoom(zoomIndex + (diff < 0 ? 1 : -1));
    }, { passive: true });
}


/* ============================
    GLOBAL QUANTITY HELPERS
============================ */

function updateMobileQuantity(change) {
    const qtyInput = document.getElementById('mobileQuantity');
    const hiddenQty = document.getElementById('mobileFinalQty');
    if (!qtyInput) return;
    const current = Math.max(1, (parseInt(qtyInput.value) || 1) + change);
    qtyInput.value = current;
    if (hiddenQty) hiddenQty.value = current;
}

function updateMobileVariant(variantId) {
    const mobileInput = document.getElementById('mobileVariantId');
    if (mobileInput) mobileInput.value = variantId;
    const mobileBtn = document.querySelector('.mobile-add-btn');
    if (mobileBtn) mobileBtn.dataset.variantId = variantId;
}

function updateQuantity(change) {
    const qtyInput = document.getElementById('quantity');
    const hiddenQty = document.getElementById('finalQty');
    if (!qtyInput) return;
    const current = Math.max(1, (parseInt(qtyInput.value) || 1) + change);
    qtyInput.value = current;
    if (hiddenQty) hiddenQty.value = current;
}
